(() => {

  'use strict';

  /* PN5A_SHARED_BOOKING_RESCHEDULE */


  if (
    window.PeerNestReschedule
  ) {
    return;
  }


  const esc =
    value =>
      String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');


  function dateText(
    value
  ) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }


    return new Intl.DateTimeFormat(
      undefined,
      {
        dateStyle:
          'medium',

        timeStyle:
          'short'
      }
    ).format(date);

  }


  function durationMinutes(
    startsAt,
    endsAt
  ) {

    const start =
      new Date(
        startsAt
      ).getTime();

    const end =
      new Date(
        endsAt
      ).getTime();


    if (
      !Number.isFinite(start) ||
      !Number.isFinite(end)
    ) {
      return 0;
    }


    return Math.round(
      (end - start) /
      60000
    );

  }


  function canReschedule(
    booking
  ) {

    if (!booking) {
      return false;
    }


    const status =
      String(
        booking.status ||
        booking.booking_status ||
        ''
      )
        .toLowerCase();


    if (
      ![
        'reserved',
        'payment_pending',
        'confirmed'
      ].includes(
        status
      )
    ) {
      return false;
    }


    const starts =
      new Date(
        booking.starts_at
      ).getTime();


    return (
      Number.isFinite(starts) &&
      starts >
      Date.now()
    );

  }


  function cleanAvailability(
    values
  ) {

    return (
      Array.isArray(values)
        ? values
        : []
    )
      .filter(
        slot =>
          slot &&
          slot.id &&
          slot.starts_at &&
          slot.ends_at
      )
      .sort(
        (a,b) =>
          new Date(
            a.starts_at
          ).getTime()
          -
          new Date(
            b.starts_at
          ).getTime()
      );

  }


  function buildBookableSlots(
    values,
    minutes
  ) {

    const atomic =
      cleanAvailability(
        values
      );


    if (
      Number(minutes) ===
      15
    ) {

      return atomic.map(
        slot => ({
          ...slot,
          duration_minutes:
            15
        })
      );

    }


    const result =
      [];

    let index =
      0;


    while (
      index <
      atomic.length - 1
    ) {

      const first =
        atomic[index];

      const second =
        atomic[index + 1];


      const consecutive =
        new Date(
          first.ends_at
        ).getTime()
        ===
        new Date(
          second.starts_at
        ).getTime();


      const sameBlock =
        String(
          first.availability_block_id ||
          ''
        )
        ===
        String(
          second.availability_block_id ||
          ''
        );


      if (
        consecutive &&
        sameBlock
      ) {

        result.push({
          ...first,

          duration_minutes:
            30,

          session_ends_at:
            second.ends_at
        });


        index += 2;

      }
      else {

        index += 1;

      }

    }


    return result;

  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:
            'POST',

          body
        }
      );

  }


  function closeModal() {

    document
      .querySelector(
        '[data-pnrs-modal]'
      )
      ?.remove();


    document.documentElement
      .classList
      .remove(
        'pnrs-is-open'
      );

  }


  function makeButton(
    booking,
    mentorId = ''
  ) {

    const button =
      document.createElement(
        'button'
      );


    button.type =
      'button';

    button.className =
      'pnrs-button';

    button.textContent =
      'Reschedule';


    button.dataset
      .pnRescheduleBooking =
        String(
          booking.id
        );


    button.dataset
      .pnRescheduleMentor =
        String(
          mentorId ||
          booking.mentor_id ||
          ''
        );


    button.dataset
      .pnRescheduleStart =
        String(
          booking.starts_at ||
          ''
        );


    button.dataset
      .pnRescheduleEnd =
        String(
          booking.ends_at ||
          ''
        );


    return button;

  }


  function attachStudentButtons(
    container,
    bookings
  ) {

    if (
      !container ||
      !Array.isArray(
        bookings
      )
    ) {
      return;
    }


    container
      .querySelectorAll(
        '.pn5-student-booking'
      )
      .forEach(
        card => {

          const bookingId =
            card.dataset
              .pn5Booking;


          const booking =
            bookings.find(
              item =>
                String(item.id) ===
                String(bookingId)
            );


          if (
            !booking ||
            !canReschedule(
              booking
            )
          ) {
            return;
          }


          /*
           * If the older dedicated Student
           * reschedule patch already exists,
           * do not create a duplicate button.
           */

          if (
            card.querySelector(
              [
                '[data-pn5-student-reschedule]',
                '[data-pn-reschedule-booking]'
              ].join(',')
            )
          ) {
            return;
          }


          const actions =
            card.querySelector(
              '.pn5-student-booking__actions'
            );


          if (!actions) {
            return;
          }


          actions.appendChild(
            makeButton(
              booking,
              booking.mentor_id
            )
          );

        }
      );

  }


  function attachMentorButtons(
    container,
    bookings
  ) {

    if (
      !container ||
      !Array.isArray(
        bookings
      )
    ) {
      return;
    }


    const cards =
      [
        ...container
          .querySelectorAll(
            '.pn5-mentor-session'
          )
      ];


    cards.forEach(
      (card,index) => {

        const booking =
          bookings[index];


        if (
          !booking ||
          !canReschedule(
            booking
          )
        ) {
          return;
        }


        if (
          card.querySelector(
            '[data-pn-reschedule-booking]'
          )
        ) {
          return;
        }


        let actions =
          card.querySelector(
            '.pn5-mentor-session__actions'
          );


        if (!actions) {

          actions =
            document.createElement(
              'div'
            );

          actions.className =
            'pn5-mentor-session__actions';


          card.appendChild(
            actions
          );

        }


        actions.appendChild(
          makeButton(
            booking
          )
        );

      }
    );

  }


  function attachAdminButtons(
    root,
    rows
  ) {

    if (
      !root ||
      !Array.isArray(
        rows
      )
    ) {
      return;
    }


    root
      .querySelectorAll(
        '.pnops__table tbody tr'
      )
      .forEach(
        tableRow => {

          const cells =
            tableRow.cells;


          if (
            !cells ||
            cells.length <
            2
          ) {
            return;
          }


          const bookingId =
            String(
              cells[1]
                ?.textContent ||
              ''
            )
              .trim();


          const booking =
            rows.find(
              row =>
                String(row.id) ===
                  bookingId
                &&
                String(
                  row._pn_type ||
                  'mentor'
                ) ===
                  'mentor'
            );


          if (
            !booking ||
            !canReschedule(
              booking
            )
          ) {
            return;
          }


          if (
            tableRow.querySelector(
              '[data-pn-reschedule-booking]'
            )
          ) {
            return;
          }


          const targetCell =
            cells[
              cells.length - 1
            ];


          if (!targetCell) {
            return;
          }


          const button =
            makeButton(
              booking,
              booking.mentor_id
            );


          button.classList.add(
            'pnrs-button--admin'
          );


          targetCell.appendChild(
            button
          );

        }
      );

  }


  async function mentorIdForButton(
    button
  ) {

    const direct =
      button.dataset
        .pnRescheduleMentor;


    if (direct) {
      return direct;
    }


    if (
      typeof window.PeerNestDB
        ?.getMyMentorProfile !==
      'function'
    ) {
      return '';
    }


    const profile =
      await window.PeerNestDB
        .getMyMentorProfile();


    return String(
      profile?.id ||
      ''
    );

  }


  async function openModal(
    button
  ) {

    closeModal();


    if (
      !window.PeerNestDB
    ) {

      window.alert(
        'PeerNest is still loading. Try again.'
      );

      return;

    }


    const bookingId =
      button.dataset
        .pnRescheduleBooking;


    const startsAt =
      button.dataset
        .pnRescheduleStart;


    const endsAt =
      button.dataset
        .pnRescheduleEnd;


    const minutes =
      durationMinutes(
        startsAt,
        endsAt
      );


    if (
      minutes !== 15 &&
      minutes !== 30
    ) {

      window.alert(
        'Only 15 or 30 minute sessions can be rescheduled.'
      );

      return;

    }


    let mentorId;


    try {

      mentorId =
        await mentorIdForButton(
          button
        );

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not load mentor information.'
      );

      return;

    }


    if (!mentorId) {

      window.alert(
        'Mentor information is unavailable.'
      );

      return;

    }


    let availability;


    try {

      availability =
        await window.PeerNestDB
          .request(
            'availability_slots',
            [
              'select=id,availability_block_id,starts_at,ends_at,status',
              `mentor_id=eq.${encodeURIComponent(
                mentorId
              )}`,
              'status=eq.available',
              `starts_at=gt.${encodeURIComponent(
                new Date().toISOString()
              )}`,
              'order=starts_at.asc',
              'limit=96'
            ].join('&')
          );

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not load available times.'
      );

      return;

    }


    const slots =
      buildBookableSlots(
        availability,
        minutes
      );


    if (!slots.length) {

      window.alert(
        `No complete ${minutes}-minute sessions are currently available.`
      );

      return;

    }


    const modal =
      document.createElement(
        'div'
      );


    modal.className =
      'pnrs-modal';

    modal.setAttribute(
      'data-pnrs-modal',
      ''
    );

    modal.setAttribute(
      'role',
      'dialog'
    );

    modal.setAttribute(
      'aria-modal',
      'true'
    );


    modal.innerHTML = `
      <div
        class="pnrs-modal__backdrop"
        data-pnrs-close
      ></div>

      <section
        class="pnrs-modal__panel"
      >

        <div
          class="pnrs-modal__heading"
        >

          <div>
            <small>
              RESCHEDULE SESSION
            </small>

            <h3>
              Choose a new time
            </h3>

            <p>
              Keep the same
              ${minutes}-minute
              session and move it to
              another available time.
            </p>
          </div>

          <button
            type="button"
            class="pnrs-modal__close"
            data-pnrs-close
            aria-label="Close"
          >
            ×
          </button>

        </div>


        <div
          class="pnrs-modal__current"
        >
          <span>
            CURRENT SESSION
          </span>

          <strong>
            ${esc(
              dateText(
                startsAt
              )
            )}
          </strong>
        </div>


        <div
          class="pnrs-modal__slots"
        >

          ${slots
            .map(
              slot => `
                <button
                  type="button"
                  class="pnrs-slot"
                  data-pnrs-slot="${esc(
                    slot.id
                  )}"
                >
                  ${esc(
                    dateText(
                      slot.starts_at
                    )
                  )}
                </button>
              `
            )
            .join('')}

        </div>


        <div
          class="pnrs-modal__footer"
        >

          <button
            type="button"
            class="pnrs-button pnrs-button--secondary"
            data-pnrs-close
          >
            Keep current time
          </button>

          <button
            type="button"
            class="pnrs-button pnrs-button--primary"
            data-pnrs-confirm
            disabled
          >
            Confirm new time
          </button>

        </div>


        <small
          class="pnrs-modal__message"
          data-pnrs-message
        >
          Choose one available
          ${minutes}-minute session.
        </small>

      </section>
    `;


    document.body.appendChild(
      modal
    );


    document.documentElement
      .classList
      .add(
        'pnrs-is-open'
      );


    let selectedSlotId =
      '';


    const confirm =
      modal.querySelector(
        '[data-pnrs-confirm]'
      );


    const message =
      modal.querySelector(
        '[data-pnrs-message]'
      );


    modal.addEventListener(
      'click',
      async event => {

        if (
          event.target.closest(
            '[data-pnrs-close]'
          )
        ) {

          closeModal();

          return;

        }


        const slotButton =
          event.target.closest(
            '[data-pnrs-slot]'
          );


        if (slotButton) {

          selectedSlotId =
            slotButton.dataset
              .pnrsSlot ||
            '';


          modal
            .querySelectorAll(
              '[data-pnrs-slot]'
            )
            .forEach(
              item => {

                item.classList.toggle(
                  'is-selected',
                  item === slotButton
                );

              }
            );


          confirm.disabled =
            !selectedSlotId;


          message.textContent =
            'New time selected. Confirm to reschedule.';


          return;

        }


        if (
          event.target.closest(
            '[data-pnrs-confirm]'
          )
        ) {

          if (!selectedSlotId) {
            return;
          }


          confirm.disabled =
            true;

          confirm.textContent =
            'Rescheduling…';

          message.textContent =
            'Securing the new session time…';


          try {

            await rpc(
              'reschedule_my_booking',
              {
                p_booking_id:
                  bookingId,

                p_new_slot_id:
                  selectedSlotId
              }
            );


            message.textContent =
              'Session rescheduled successfully.';


            setTimeout(
              () => {
                window.location.reload();
              },
              250
            );

          }
          catch (error) {

            confirm.disabled =
              false;

            confirm.textContent =
              'Confirm new time';


            message.textContent =
              error?.message ||
              'Could not reschedule this session.';

          }

        }

      }
    );

  }


  document.addEventListener(
    'click',
    event => {

      const button =
        event.target.closest(
          '[data-pn-reschedule-booking]'
        );


      if (!button) {
        return;
      }


      event.preventDefault();


      openModal(
        button
      );

    }
  );


  window.PeerNestReschedule =
    Object.freeze({

      attachStudentButtons,

      attachMentorButtons,

      attachAdminButtons

    });


})();
